import { render, staticRenderFns } from "./VTableHeadData.vue?vue&type=template&id=c45aca66&"
import script from "./VTableHeadData.vue?vue&type=script&lang=js&"
export * from "./VTableHeadData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports